import { render, staticRenderFns } from "./ttcIframe.vue?vue&type=template&id=14321272&scoped=true&"
import script from "./ttcIframe.vue?vue&type=script&lang=js&"
export * from "./ttcIframe.vue?vue&type=script&lang=js&"
import style0 from "./ttcIframe.vue?vue&type=style&index=0&id=14321272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14321272",
  null
  
)

export default component.exports